import React, { useState, useEffect } from "react";

import { useHistory } from "react-router-dom";

// Components imports
import InputField from "../../components/common/InputField";
import SelectElement from "../../components/common/SelectElement";
import Button from "../../components/common/Button";
import NavigationBar from "../../components/common/NavigationBar";

// redux
import { useSelector, useDispatch } from "react-redux";
import {
  updateCertainUser,
  deleteCertainUser,
} from "../../redux/actions/allUsers";

// Scss imports
import css from "./UserProfile.module.scss";

interface UserProfileProps {
  text?: string;
}

const UserProfile: React.FC<UserProfileProps> = ({}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  // Curent user data
  const certainUserData = useSelector(
    (state: any) => state.allUsers.certainUser
  );

  // Updation message
  const updateMessage = useSelector(
    (state: any) => state.allUsers.updateMessage
  );

  // Updation fields status
  const status = useSelector((state: any) => state.allUsers.status);

  // Setting up state to hold data for forms
  const [firstName, setFirstName] = useState(certainUserData.firstName);
  const [lastName, setLastName] = useState(certainUserData.lastName);
  const [businessName, setBusinessName] = useState(
    certainUserData.businessName
  );
  const [nationalId, setNationalId] = useState(certainUserData.nationalId);
  const [email, setEmail] = useState(certainUserData.email);
  const [phone, setPhone] = useState(certainUserData.phone);
  const [place, setPlace] = useState(certainUserData.place);
  const [municipality, setMunicipality] = useState(
    certainUserData.municipality
  );
  const [street, setStreet] = useState(certainUserData.street);
  const [buildingNumber, setBuildingNumber] = useState(
    certainUserData.buildingNumber
  );
  const [apartmentNumber, setApartmentNumber] = useState(
    certainUserData.apartmentNumber
  );
  const [letter, setLetter] = useState(certainUserData.letter);
  const [floor, setFloor] = useState(certainUserData.floor);
  const [zipCode, setZipCode] = useState(certainUserData.zipCode);
  const [subscriptionDate, setSubscriptionDate] = useState(
    certainUserData.subscriptionDate
  );
  const [subscriptionLeft, setSubscriptionLeft] = useState(
    certainUserData.subscriptionLeft
  );
  const [identificationNumber, setIdentificationNumber] = useState(
    certainUserData.identificationNumber
  );
  const [subscriptionTime, setSubscriptionTime] = useState(
    certainUserData.subscriptionTime
  );

  // Event for sending basic data to the database
  /**const sendContactDataEvent = () => {
    const contactDataForm = () => {
      return {
        ...(email !== certainUserData.email && {
          email: email
        }),
        ...(phone !== certainUserData.phone && { phone: phone })
      };
    };

    const object: any = contactDataForm();

    setSendingBlock("contact");

    console.log(object);

    sendDataToTheDatabase(object, contactDataForm, setMessageContactText);
  };*/

  const [role, setRole] = useState("");
  const [activity, setActivity] = useState("");

  const onSelectChange = (e, setValue) => {
    setValue(e.target.value);
  };

  const roleArray = [
    {
      value: "",
      name: "Изабери",
    },
    {
      value: "admin",
      name: "Админ",
    },
    {
      value: "user",
      name: "Корисник",
    },
    { value: "pending", name: "На чекању" },
  ];

  const activityArray = [
    {
      value: "",
      name: "Изабери",
    },
    {
      value: "true",
      name: "Активан",
    },
    {
      value: "false",
      name: "Неактиван",
    },
  ];

  const changeRole = () => {
    dispatch(updateCertainUser({ role: role }, certainUserData.id, history));
  };

  const changeActivity = () => {
    dispatch(
      updateCertainUser({ active: activity }, certainUserData.id, history)
    );
  };

  const extendUserSubscription = () => {
    dispatch(
      updateCertainUser(
        {
          subscribe: true,
        },
        certainUserData.id,
        history
      )
    );
  };

  const deleteUser = () => {
    dispatch(deleteCertainUser(certainUserData.id, history));
  };

  return (
    <div className={css.mainContainer}>
      <NavigationBar />
      <h1>Кориснички подаци</h1>
      <div className={css.dataContainer}>
        {/*<div className={css.containerSubscription}>
          <div>
            <p>
              <span>Датум претплате: </span>
              {certainUserData.subscriptionDate
                ? certainUserData.subscriptionDate.split("T")[0]
                : ""}
            </p>
            <p>
              <span>Крај претплате: </span>
              {certainUserData.subscriptionLeft
                ? certainUserData.subscriptionLeft.split("T")[0]
                : ""}
            </p>
            <p>
              <span>Укупно време претплате: </span>
              {certainUserData.subscriptionTime}
            </p>
          </div>
							</div>*/}
        {/* Basic account data */}
        <div className={css.wrapperContainer}>
          <div className={css.container}>
            <div>
              <h2 className={css.title}>Основни подаци</h2>

              <p>
                <span>Име: </span>
                {certainUserData.firstName}
              </p>
              <p>
                <span>Презиме: </span>
                {certainUserData.lastName}
              </p>

              <p>
                <span>Пословно име: </span>
                {certainUserData.businessName}
              </p>

              {/*<p>
                <span>Јединствени матични број: </span>
                {certainUserData.nationalId}
            </p>
              <p>
                <span>Матични број: </span>
                {certainUserData.identificationNumber}
              </p>
              <p>
                <span>Порески број: </span>
                {certainUserData.taxId}
              </p>*/}
            </div>
          </div>
        </div>
        {/* Residence data */}
        <div className={css.wrapperContainer}>
          <div className={css.container}>
            <div>
              <h2 className={css.title}>Подаци о пребивалишту</h2>

              <p>
                <span>Место: </span>
                {certainUserData.place}
              </p>
              <p>
                <span>Општина: </span>
                {certainUserData.municipality}
              </p>
              <p>
                <span>Улица: </span>
                {certainUserData.street}
              </p>
              <p>
                <span>Број зграде: </span>
                {certainUserData.buildingNumber}
              </p>
              <p>
                <span>Број стана: </span>
                {certainUserData.apartmentNumber}
              </p>
              <p>
                <span>Спрат: </span>
                {certainUserData.floor}
              </p>
              <p>
                <span>Слово: </span>
                {certainUserData.letter}
              </p>
              <p>
                <span>Поштански број: </span>
                {certainUserData.zipCode}
              </p>
            </div>
          </div>
        </div>

        {/*Contact data */}
        <div className={css.wrapperContainer}>
          <div className={css.container}>
            <div>
              <h2 className={css.title}>Контакт подаци</h2>

              <p>
                <span>Имејл адреса: </span>
                {certainUserData.email}
              </p>
              <p>
                <span>Број телефона: </span>
                {certainUserData.phone}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* edit data */}
      <>
        <h1>Промена података</h1>
        <div
          className={`${
            status === "fail" ? css.errorMessage : css.messageText
          } `}
        >
          <p>
            {status === "fail"
              ? updateMessage
              : "Успешно сте променили податке профила"}
          </p>
        </div>
        <div className={css.editData}>
          <div className={css.wrapperContainer}>
            <h2 className={css.title}>Улога</h2>
            <p>
              <span>Улога: </span> {certainUserData.role}
            </p>

            <div className={css.selectWrapper}>
              <SelectElement
                label="Промени улогу"
                id="role"
                name="role"
                handleChange={(e) => onSelectChange(e, setRole)}
                selectOptionsArray={roleArray}
                minLabelWidth={true}
                type="filterSelect"
              />
            </div>
            <div className={css.buttonWrapper}>
              <Button
                text="Пошаљи"
                onButtonClickHandler={changeRole}
                style={{
                  borderRadius: "5rem",
                  maxHeight: "6rem",
                  border: "0.1rem solid gray",
                }}
                disabledButton={role.length < 1 ? true : false}
              />
            </div>
          </div>
          <div className={css.wrapperContainer}>
            <h2 className={css.title}>Претплата</h2>
            <div>
              <p>
                <span>Датум претплате: </span>
                {certainUserData.subscriptionDate
                  ? certainUserData.subscriptionDate.split("T")[0]
                  : ""}
              </p>
              <p>
                <span>Крај претплате: </span>
                {certainUserData.subscriptionLeft
                  ? certainUserData.subscriptionLeft.split("T")[0]
                  : ""}
              </p>
              <p>
                <span>Укупно време претплате: </span>
                {certainUserData.subscriptionTime}
              </p>
            </div>
            <div className={css.buttonWrapperSubscription}>
              <Button
                text="Продужи претплату"
                onButtonClickHandler={extendUserSubscription}
                style={{
                  borderRadius: "5rem",
                  maxHeight: "6rem",
                  border: "0.1rem solid gray",
                }}
              />
            </div>
          </div>
          <div className={css.wrapperContainer}>
            <h2 className={css.title}>Контрола брисања</h2>
            <p>
              <span>Активност: </span>
              {certainUserData.active ? "Активан" : "Неактиван"}
            </p>

            <div className={css.selectWrapper}>
              <SelectElement
                label="Промени активност"
                id="activity"
                name="activity"
                handleChange={(e) => onSelectChange(e, setActivity)}
                selectOptionsArray={activityArray}
                minLabelWidth={true}
                type="filterSelect"
              />
            </div>
            <div className={css.buttonDelete}>
              <Button
                text="Пошаљи"
                onButtonClickHandler={changeActivity}
                style={{
                  borderRadius: "5rem",
                  maxHeight: "6rem",
                  border: "0.1rem solid gray",
                }}
                disabledButton={activity.length < 1 ? true : false}
              />
            </div>
            {/*<h3>Трајно брисање</h3>
            <div className={css.buttonDeleteTwo}>
              <Button
                text="Обриши корисника"
                onButtonClickHandler={deleteUser}
                style={{
                  borderRadius: "5rem",
                  maxHeight: "6rem",
                  border: "0.1rem solid gray"
                }}
              />
              </div>*/}
          </div>
        </div>
      </>
    </div>
  );
};

export default UserProfile;
